<template lang="pug">
    title-modal-layout.subscribe-modal(v-if="!loading" v-bind="$attrs" title="Subscriptions" :disableButtons="!hasProducts" @approve="subscribe")
        template(v-slot:section)
            scrollable-layout.subscribe-modal__scroll(v-if="hasProducts" :maxHeight="true")
                template(v-for="product in products")
                    subscribe-modal-plan(v-for="plan in product.plans.data" :key="plan.code"
                        :product="product" :plan="plan" :subscription="subscription(plan)"
                        :disabled="disabled(product)"
                        :selected="planCode == plan.code"
                        :deleted="!product.is_active || !plan.is_active"
                        @select="select(product, plan)"
                        @cancel="cancel(product, plan)"
                    )

            div.subscribe-modal__empty(v-else) There are no subscriptions set.

        template(v-slot:buttons="{ approve }")
            button-control(:disabled="!plan" @click="approve") Subscribe
</template>

<script>
import UserProductsService from '../../services/user-products-service'
import UserFollowsService from '../../services/user-follows-service'

export default {
    name: 'subscribe-modal',

    props: {
        user: {
            type: Object,
            required: true,
        },
        subscriptionIds: {
            type: Array,
        },
    },

    data() {
        return {
            products: [],
            product: null,
            plan: null,
            planCode: null,
            loading: false,
            subscriptions: [],
        }
    },

    async created() {
        this.loading = true
        await this.loadProducts()
        await this.loadSubscriptions()
        this.selectAloneProductPlan()
        this.loading = false
    },

    computed: {
        hasProducts() {
            return this.products.length > 0
        },
    },

    methods: {
        async loadProducts() {
            const products = await UserProductsService.byType(this.user.id, 'subscription')
            this.products = this.subscriptionIds ? products.filter(p => this.subscriptionIds.includes(p.id.toString())) : products
        },

        async loadSubscriptions() {
            const { data: { data: subscriptions } } = await axios.get('/api/customer/subscription?include=plan.product.user')

            const activeStatuses = window.addiesaas.subscriptions.statuses.active
            this.subscriptions = subscriptions.filter(s => s.plan.data.product.data.user.data.id == this.user.id && activeStatuses.includes(s.status))

            for (const subscription of this.subscriptions) {
                const plan = subscription.plan.data
                const product = plan.product.data

                let existingProduct = this.products.find(p => p.id == product.id)
                if (!existingProduct) {
                    product.plans.data = []
                    this.products.unshift(product)
                    existingProduct = product
                }

                let existingPlan = existingProduct.plans.data.find(p => p.id == plan.id)
                if (!existingPlan) {
                    existingProduct.plans.data.unshift(plan)
                    existingPlan = plan
                }
            }

            this.products.sort((a, b) => {
                const aSubscribed = this.isProductSubscribed(a)
                const bSubscribed = this.isProductSubscribed(b)
                if (aSubscribed && !bSubscribed) {
                    return -1
                }
                if (!aSubscribed && bSubscribed) {
                    return 1
                }
                return 0
            })

            this.products.forEach(product => {
                product.plans.data.sort((a, b) => {
                    const aSubscribed = this.isPlanSubscribed(a)
                    const bSubscribed = this.isPlanSubscribed(b)
                    if (aSubscribed && !bSubscribed) {
                        return -1
                    }
                    if (!aSubscribed && bSubscribed) {
                        return 1
                    }
                    return 0
                })
            })
        },

        isProductSubscribed(product) {
            return Boolean(this.subscriptions.find(s => s.plan.data.product.data.id == product.id))
        },

        isPlanSubscribed(plan) {
            return Boolean(this.subscriptions.find(s => s.plan.id == plan.id))
        },
    
        selectAloneProductPlan() {
            let count = 0
            this.products.forEach(p => count += p.plans.data.length)

            if (count === 1) {
                this.select(this.products[0], this.products[0].plans.data[0])
            }
        },

        select(product, plan) {
            this.product = product
            this.plan = plan
            this.planCode = plan.code
        },

        async cancel(product, plan) {
            const subscription = this.subscription(plan)
            await axios.post(`/api/customer/subscription/${subscription.id}/stop`)
            await this.loadSubscriptions()
        },

        subscribe({ success }) {
            this.subscribing = true
            if (!this.added()) {
                this.$store.dispatch('Shop/Orders/Cart/addCartItem', {
                    type: 'subscription',
                    payload: {
                        product_id: this.product.id,
                        options: {
                            plan: this.planCode,
                        },
                    },
                    attributes: {
                        product: this.product,
                        title: this.product.title + (this.plan.display_name ? (' / ' + this.plan.display_name) : ''),
                    },
                    total: this.plan.initial_amount || this.plan.amount,
                })
            }
            if (!this.user.is_followed) {
                UserFollowsService.follow(this.user.id)
            }
            success()
            this.$router.push({ name: 'shopping-cart-page' })
        },

        subscription(plan) {
            return this.subscriptions.find(subscription => subscription.plan.data.id == plan.id)
        },

        disabled(product) {
            return !!this.subscriptions.find(subscription => subscription.plan.data.product.data.id == product.id)
        },

        added() {
            const cartItems = this.$store.getters['Shop/Orders/Cart/cartItems'] || {}
            return Object.values(cartItems).some(x => {
                return x.type == 'subscription' &&
                    x.payload.product_id == this.product.id &&
                    x.payload.options.plan == this.planCode
            })
        },
    },
}
</script>